import { useMemo } from "react"
import _, { merge } from "lodash"
import { EXTENSION_NAME } from "../../constants"
import { useExtension } from "hooks/extension/useExtension"

interface INextopiaConfig {
  // Show or hide the weather widget on the Nextopia detail page and the
  // kiosk-v map / quick-search pages.
  enableWeatherWidget: boolean
}
const DEFAULT_NEXTOPIA_CONFIG = {
  enableWeatherWidget: false,
}
export const useNextopiaConfig = (): INextopiaConfig => {
  const { extensionConfig } = useExtension()

  const nextopiaConfig = useMemo(() => {
    const fetchedConfig =
      _.get(extensionConfig, `${EXTENSION_NAME}.options.nextopia`, {}) || {}

    return merge({}, DEFAULT_NEXTOPIA_CONFIG, fetchedConfig)
  }, [extensionConfig])

  return nextopiaConfig
}
